

import { Card, Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../../services/api';
import Loading from '../../../../../load/loading';
import LoadingShort from '../../../../../load/loadingShort';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import compressImage from '../../../../../services/compressImage';
import CloseIcon from '@mui/icons-material/Close';
import Date from '../../../../../utils/date';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Avatar } from '@material-ui/core';
import AtribuicaoQuota from './atribuicaoQuota';
import ApproveProduto from './approveProduto';
import AddCategoriaProducto from './addCategoriaProducto';
import AddTeorBaseProducto from './addTeorBaseProducto';
import VerifyPermission from '../../../../../utils/verifyPermission';
import InfoFieldGroup from '../../../../../utils/InfoField/InfoFieldGroup';
import StatusSolicitacoes from '../../../../../utils/status/statusSolicitacoes';
import MessageSuccess from '../../../../../messages/messageSuccess';
import MessageError from '../../../../../messages/messageError';


export default function Produto({ solicitacaoImportacao }) {
    const user = useSelector(state => state.account.user);
    const [editDados, setEditDados] = useState('');
    const [isEdit, setIsEdit] = useState('');
    const { id, produtoId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loadAddImage, setLoadAddImage] = useState(false)
    const [produto, setProduto] = useState('')
    const [openImagensCapturadas, setOpenImagensCapturadas] = useState(false);
    const [load, setLoad] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setMessageError] = useState('');


    useEffect(() => {
        api.get(`/producto/${produtoId}`)
            .then(response => {
                setProduto(response.data.producto);
            }).catch(err => { console.log(err) });
    }, [id, produtoId, setProduto, isEdit])

    // ADICIONAR IMAGEM DA AMOSTRA
    async function postImage(e) {
        setLoadAddImage(true)
        let imageComprimida = await compressImage(e.target.files[0])

        const formData = new FormData();
        formData.append('imagem', imageComprimida);
        formData.append('productoId', produto?._id);
        formData.append('userId', user?._id);

        await api.patch(`/producto/add-image`, formData)
            .then(response => {
                setProduto(response.data.producto);
                setLoadAddImage(false)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Amostra adicionada.!' },
                });

            }).catch(err => {
                setLoadAddImage(false)
            })
    }


    const submitEdit = async () => {

        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/producto/edit', { ...editDados, productoId: produtoId, 'userId': user?._id ?? '' })
            .then(res => {
                // console.log(res.data.producto)
                // console.log(editDados)
                // setDadosEmpresa(res.data.empresa)
                // setRefresh(res.data.empresa)
                setLoad(false)
                // setMessageSuccess(res.data.msg)
                setIsEdit(false);


            }).catch(err => {
                // console.log(err)
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    const CaptureImage = () => {
        return (
            <>
                <IconButton size='large'  >
                    {loadAddImage ? <LoadingShort />
                        :
                        <label htmlFor="capitureImage" >
                            <Tooltip title="Carregar imagens da amostra">
                                <CameraAltIcon />
                            </Tooltip>
                        </label>
                    }
                </IconButton>
                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="capitureImage" style={{ display: 'none' }} onChange={postImage} />
            </>
        )
    }

    const categoriaOptions = useMemo(() => {
        if (produto?.tipo === 'Não Controlados') {
            return [
                { designacao: 'Especiais' },
                { designacao: 'Geral' }
            ];
        }

        if (produto?.tipo === 'Controlados') {
            return [
                { designacao: 'Especiais' },
                { designacao: 'Estupefaciente' },
                { designacao: 'Percursores' },
                { designacao: 'Psicotrópico' }
            ];
        }
        return [];
    }, [produto?.tipo]);


    // '',
    // 'Tecnologia de Saúde',
    //  'Equipamentos',
    //  'Meios de diagnóstico',
    //  'Material Gastável',
    //  'Produtos diverso',
    const tipoOptions = [{ designacao: 'Medicamento' }, { designacao: 'Tecnologia de Saúde' }, { designacao: 'Equipamentos' }, { designacao: 'Meios de diagnóstico' }, { designacao: 'Material Gastável' }, { designacao: 'Produtos diverso' }];


    return (
        produto ?
            <>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <Card style={{ padding: 20, position: 'relative' }}>

                    <IconButton title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => { navigate(-1) }}> <CloseIcon /></IconButton>

                    <HeaderGestorConfigs
                        menu={false}
                        configArea={''}
                        title={'PRODUTO'}
                    />

                    <InfoFieldGroup
                        editable={produto?.status !== 'Aprovado' ? true : false}
                        submit={submitEdit}
                        data={editDados}
                        // handleChange={handleChange}
                        setIsEdit={setIsEdit}
                        isEdit={isEdit}
                        load={load}
                        fields={
                            [
                                { label: 'Estado', value: <StatusSolicitacoes status={produto?.status} />, editable: false, },
                                { label: 'Nome', value: produto?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                { label: 'Nome Comercial', value: produto?.nomeComercial, key: 'nomeComercial', onChange: (v) => setEditDados({ ...editDados, nomeComercial: v.target.value }) },
                                { label: 'Principio Activo', value: produto?.principioActivo, key: 'principioActivo', onChange: (v) => setEditDados({ ...editDados, principioActivo: v.target.value }) },
                                { label: 'Forma Farmaceutica', value: produto?.formaFarmaceutica, key: 'formaFarmaceutica', onChange: (v) => setEditDados({ ...editDados, formaFarmaceutica: v.target.value }) },
                                { label: 'Descrição das Substâncias Activas', value: produto?.descicaoSubstanciasActivas, key: 'descicaoSubstanciasActivas', onChange: (v) => setEditDados({ ...editDados, descicaoSubstanciasActivas: v.target.value }) },
                                { label: 'Categória', value: produto?.categoria, key: 'categoria', type: 'select', options: categoriaOptions, onChange: (v) => setEditDados({ ...editDados, categoria: v.target.value }) },
                                { label: 'Tipo de Produto', value: produto?.tipo, key: 'tipo', type: 'select', options: tipoOptions, onChange: (v) => setEditDados({ ...editDados, tipo: v.target.value }) },
                                { label: 'Lote', value: produto?.lote, key: 'lote', onChange: (v) => setEditDados({ ...editDados, lote: v.target.value }) },
                                { label: 'Marca', value: produto?.marca, key: 'marca', onChange: (v) => setEditDados({ ...editDados, marca: v.target.value }) },

                                ...((produto?.categoria && produto?.categoria !== 'Especiais') ? [
                                    { label: 'TeorBase (g)', value: produto?.teorBaseG, key: 'teorBaseG', onChange: (v) => setEditDados({ ...editDados, teorBaseG: v.target.value }) },
                                ] : []),

                                ...(produto?.tipo !== 'Não Controlados' ? [
                                    { label: 'Dosagem/Concentração', value: produto?.dosagemConcentracao, key: 'dosagemConcentracao', onChange: (v) => setEditDados({ ...editDados, dosagemConcentracao: v.target.value }) },
                                ] : []),

                                { label: 'Fabricante / Laboratório', value: produto?.fabricante, key: 'fabricante', onChange: (v) => setEditDados({ ...editDados, fabricante: v.target.value }) },
                                { label: 'Endereço do Fabricante', value: produto?.enderecoFabricante, key: 'enderecoFabricante', onChange: (v) => setEditDados({ ...editDados, enderecoFabricante: v.target.value }) },
                                { label: 'Data de Fabrico', value: isEdit ? produto?.dataFabrico?.substring(0, 10) : <Date date={produto?.dataFabrico} />, type: 'date', key: 'dataFabrico', onChange: (v) => setEditDados({ ...editDados, dataFabrico: v.target.value }) },
                                { label: 'Data de Validade', value: isEdit ? produto?.dataValidade?.substring(0, 10) : <Date date={produto?.dataValidade} />, type: 'date', key: 'dataValidade', onChange: (v) => setEditDados({ ...editDados, dataValidade: v.target.value }) },

                                ...(produto?.tipo === 'Controlados' ? [
                                    { label: 'Quota', value: produto?.quota, key: 'quota', editable: false, onChange: (v) => setEditDados({ ...editDados, quota: v.target.value }) },
                                ] : []),
                            ]
                        } />

                    {/* OPCIOANL PARA ADCIONAR IMAGENS  */}
                    <CaptureImage />

                    {/* LISTA DE IMAGENS DE AMOSTRAS CAPTURADAS */}
                    <List
                        sx={{ width: '100%', minWidth: '100%', bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItemButton onClick={() => setOpenImagensCapturadas(!openImagensCapturadas)}>
                            <ListItemIcon>
                                {produto.imagens.map((foto, index) =>
                                    index < 10 &&
                                    <Avatar key={index} variant='square' id={index} src={foto} style={{ margin: 5 }} />
                                )}
                            </ListItemIcon>
                            <ListItemText primary="IMAGENS DO PRODUTO" />
                            {openImagensCapturadas ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={openImagensCapturadas} timeout="auto" unmountOnExit>
                            {produto.imagens.map((foto, index) =>
                                <div key={index} style={{ position: 'relative' }}>
                                    <img id={index} src={foto} style={{ marginBottom: 10 }} />
                                </div>
                            )}
                        </Collapse>
                    </List>
                </Card>

                {/* {(produto?.approved === false && solicitacaoImportacao.status !== 'Aprovado' && produto?.tipo !== 'Não Controlados') && */}
                {(produto?.approved === false && solicitacaoImportacao.status !== 'Aprovado') &&
                    <>
                        {/* <br />
                        <AddCategoriaProducto
                            produto={produto}
                            setProduto={setProduto}
                        /> */}
                        {/* <br />
                        {(produto?.categoria && produto?.categoria !== 'Especiais') &&
                            <AddTeorBaseProducto
                                produto={produto}
                                setProduto={setProduto}
                            />
                        } */}

                        {produto?.tipo === 'Controlados' &&
                            <>
                                <br />
                                <AtribuicaoQuota
                                    produto={produto}
                                    setProduto={setProduto}
                                />
                            </>
                        }

                        <br />
                        <VerifyPermission permissions={user?.permissions} permission={'approveProdutoListaControlados'}>
                            <ApproveProduto
                                producto={produto}
                                setProduto={setProduto}
                                solicitacaoImportacao={solicitacaoImportacao}
                            />
                        </VerifyPermission>
                    </>
                }
            </>
            :
            <Loading text={'Acarregar produto..'} />
    )
}
